import React, { useState, useEffect, useRef } from 'react';
import { StyledButtonSalvar, StyledButtonNovo, StyledButtonPesquisar } from './../styles';
import Swal from 'sweetalert2';
import { Label, ButtonContainer, MainContainer, ProfileContainerInfo, FormContainer, Row, ShowInput } from './style';
import Search from './Search';
import CloseButton from './CloseButton';
import { motion } from "framer-motion";
import { useSelector } from "react-redux";
import { projectService } from '../../../services/projectService';

const CreditoCarbono = ({ project_id }) => {
  const [isLoading, setIsLoading] = useState(false);
  const [id, setId] = useState('');
  const [safra, setSafra] = useState('');
  const [quantidade, setQuantidade] = useState('');
  const [isSearching, setIsSearching] = useState(false);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [selectedItem, setSelectedItem] = useState(null);
  const safra1Ref = useRef(null);
  const collapsed = useSelector((state) => state.sidebar);

  useEffect(() => {
    if (selectedItem) {
      setId(selectedItem.id);
      setSafra(selectedItem.safra);
      setQuantidade(selectedItem.quantidade);
    }
  }, [selectedItem]);

  const handleSalvarClick = async () => {
    setIsLoading(true);

    try {
      const formData = new FormData();
      formData.append('id', id);
      formData.append('safra', safra);
      formData.append('quantidade', quantidade);
      formData.append('project', parseInt(project_id));

      const token = sessionStorage.getItem('Authorization');

      let response;

      if (id === '') {
        // ✅ Inserção
        response = await projectService.insertProjectCarbonCredit(formData, token);
        console.log('Inserido com sucesso! Resposta da API:', response);
      } else {
        // ✅ Atualização
        response = await projectService.updateProjectCarbonCredit(id, formData, token);
        console.log('Atualizado com sucesso! Resposta da API:', response);
      }

      // 🧹 Limpar campos
      setId('');
      setSafra('');
      setQuantidade('');
      safra1Ref.current.focus();

      Swal.fire({
        title: 'Sucesso!',
        text: 'Seus dados foram salvos com sucesso!',
        icon: 'success',
        confirmButtonText: 'OK',
      });
    } catch (error) {
      console.error('Erro na chamada da API:', error);

      Swal.fire({
        title: 'Erro!',
        text: 'Algo deu errado. Por favor, contate nosso suporte! suporte@vertecotech.com',
        icon: 'error',
        confirmButtonText: 'OK',
      });
    } finally {
      setIsLoading(false);
    }
  };

  const handleNovoClick = () => {
    setId('');
    setSafra('');
    setQuantidade('');
    safra1Ref.current.focus();
  };

  const handlePesquisarClick = () => {
    setIsSearching(!isSearching);
    setIsModalOpen(true);
  };

  const closeModal = () => {
    setIsModalOpen(false);
    safra1Ref.current.focus();
  };

  const PreencheItem = (item) => {
    setSelectedItem(item);
    console.log("credito carbono : " + selectedItem);
  };

  return (
    <MainContainer>
      <motion.div
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        exit={{ opacity: 0 }}
        transition={{ duration: 0.8 }}
      >
        <ProfileContainerInfo collapsed={collapsed}>
          <h2>Crédito de Carbono</h2>

          <FormContainer>

            <Row>
              <Label htmlFor="safra1">SAFRA</Label>
              <ShowInput
                type="text"
                id="safra1"
                name="safra1"
                value={safra}
                onChange={(e) => setSafra(e.target.value)}
                ref={safra1Ref}
              />
            </Row>

            <Row>
              <Label htmlFor="quantidade">QUANTIDADE</Label>
              <ShowInput
                type="text"
                id="quantidade"
                name="quantidade"
                value={quantidade}
                onChange={(e) => setQuantidade(e.target.value)}
              />
            </Row>

          </FormContainer>
        </ProfileContainerInfo>

        <ButtonContainer>
          <StyledButtonSalvar onClick={handleSalvarClick}>Salvar</StyledButtonSalvar>
          <StyledButtonNovo onClick={handleNovoClick}>Novo</StyledButtonNovo>
          <StyledButtonPesquisar onClick={handlePesquisarClick}>Pesquisar</StyledButtonPesquisar>
        </ButtonContainer>

        {isModalOpen && (
          <div>
            <CloseButton closeModal={closeModal} />
            <Search onCloseModal={closeModal} PreencheItem={PreencheItem} />
          </div>
        )}
      </motion.div>
    </MainContainer>
  );
};

export default CreditoCarbono;
